export const arrayToString = (array?: string[] | string) => {
	if (Array.isArray(array)) {
		return array.join(" ");
	}

	return array;
};
